'use strict';

angular.module('substoreApp.controllers')
    .controller('orderadministrationselectionController', OrderadministrationselectionController);

function OrderadministrationselectionController($scope, $routeParams, dialogData, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("administration");

    $scope.progressBar.setup({ step: 1, administration: true });

    $scope.confirmation = {
        requestedParameterValue: $routeParams.requestedParameterValue
    };

    var subscriptionTemplateId = $routeParams.subscriptionTemplateId;
    var uniqueSubscriptionId = $routeParams.uniqueSubscriptionId;

    function initDialogData() {
        var data = $scope.data = dialogData;

        var product = productDataCollector.collect(data.product);

        $scope.updateTeaser(
            product.texts.headerTitleAdministrationSelection,
            product.texts.headerSubTitleAdministrationSelection,
            product.images.headerImageAdministrationSelection);

        htmlTruster.trust($scope.data.product);

        $scope.footnotes = product.productDescription.footnotes;

        $scope.applyFeature($scope, [ $scope.data.partnerName, 'orderadministrationselection', 'dialog' ]);

        webtrekk.track('order_administration_selection', {
            page_content_id: product.texts.productName.toString() + "-" + product.subscriptionTemplateId,
            shop_product_sku: product.subscriptionTemplateId
        });
    }

    $scope.nextClicked = false;

    $scope.next = function() {
        if ($scope.nextClicked)
            return;
        var valid = $scope.applyFeature($scope, [ $scope.data.partnerName, 'orderadministrationselection', 'validation' ]);
        if (valid) {
            $scope.nextClicked = true;

            $scope.go("/orderadministrationsummary/" + subscriptionTemplateId + "/" + uniqueSubscriptionId + "/" + $scope.confirmation.requestedParameterValue);
        }
    };

    $scope.cancel = function() {
        if ($scope.nextClicked)
            return;
        $scope.nextClicked = true;
        $scope.go("/myproducts");
    };

    initDialogData();
}
